const bbtClass = 'black-block-title';

const BlackBlockTitles = (() => {

	const bbt = {
		instances: [],
	};

	bbt.init = function() {
		const instances = Array.from(document.querySelectorAll(`.${bbtClass}`));
		if (!instances || !instances.length) {
			return;
		}

		bbt.instances = instances;

		window.addEventListener('resize', bbt.updateBlocks, {passive: true});

		bbt.updateBlocks();

		window.addEventListener('DOMContentLoaded', bbt.updateBlocks, {once: true});
		window.addEventListener('load', bbt.updateBlocks, {once: true});
	}


	bbt.onWindowResize = function(e) {
		bbt.updateBlocks()
	}

	bbt.updateBlocks = function() {
		if (bbt.instances && bbt.instances.length) {
			bbt.instances.forEach(block => {
				const sizer = bbt.getSizer(block);
				const offsetWidth = sizer.offsetWidth;

				block.style.setProperty('--title-size', offsetWidth + 'px');
			});
		}
	}

	bbt.getSizer = function(block) {
		if (!block) {
			return;
		}

		return block.querySelector(`.${bbtClass}__sizer`);
	}

	bbt.unload = function() {
		window.removeEventListener('resize', bbt.updateBlocks);
	}

	return bbt;

})();

export default BlackBlockTitles;



// WEBPACK FOOTER //
// ./scripts/modules/black-block-titles.js